import React from 'react';
import { MapPin, Clock, Calendar, Video, Users } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ClassRecord } from '../../data/classes';
interface ClassCardProps {
  classRecord: ClassRecord;
  onClick: (classRecord: ClassRecord) => void;
}
export function ClassCard({
  classRecord,
  onClick
}: ClassCardProps) {
  const isCancelled = classRecord.status === 'cancelled';
  const isJon = classRecord.instructorGroup === 'Jon Kichen';
  return <Card className={`p-6 flex flex-col h-full border-l-4 ${isCancelled ? 'bg-gray-50 border-l-gray-300' : isJon ? 'bg-white border-l-brand-purple-600' : 'bg-white border-l-brand-orange-500'}`} hoverEffect={!isCancelled} data-id="element-67">
      {/* Badges */}
      <div className="flex flex-wrap gap-2 mb-4" data-id="element-68">
        {isCancelled && <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-red-50 text-red-700 border border-red-200" data-id="element-69">
            Cancelled
          </span>}
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-70">
          {classRecord.format}
        </span>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200" data-id="element-71">
          {classRecord.ceCategory}
        </span>
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${isJon ? 'bg-brand-purple-50 text-brand-purple-700 border-brand-purple-200' : 'bg-brand-orange-50 text-brand-orange-800 border-brand-orange-200'}`} data-id="element-72">
          <span className={`w-2 h-2 rounded-full mr-1.5 ${isJon ? 'bg-brand-purple-600' : 'bg-brand-orange-500'}`} data-id="element-73"></span>
          {classRecord.instructorGroup}
        </span>
      </div>

      {/* Title + Price */}
      <div className="flex justify-between items-start gap-4 mb-5" data-id="element-74">
        <h3 className={`text-lg font-bold leading-snug ${isCancelled ? 'text-gray-500 line-through' : 'text-gray-900'}`} data-id="element-75">
          {classRecord.title}
        </h3>
        <div className="text-right flex-shrink-0" data-id="element-76">
          <div className={`text-lg font-bold ${classRecord.price === 'Free' ? 'text-green-600' : 'text-gray-900'}`} data-id="element-77">
            {classRecord.price}
          </div>
          <div className="text-xs text-gray-500" data-id="element-78">{classRecord.hours} hrs</div>
        </div>
      </div>

      {/* Meta details */}
      <div className="space-y-2.5 mb-6 flex-grow" data-id="element-79">
        <div className="flex items-center text-sm text-gray-700" data-id="element-80">
          <Calendar className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-81" />
          <span className="font-medium text-gray-900" data-id="element-82">
            {new Date(classRecord.date + 'T00:00:00').toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          })}
          </span>
        </div>
        <div className="flex items-center text-sm text-gray-700" data-id="element-83">
          <Clock className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-84" />
          {classRecord.startTime} - {classRecord.endTime}
        </div>
        <div className="flex items-center text-sm text-gray-700" data-id="element-85">
          {classRecord.format === 'Zoom' ? <Video className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-86" /> : <MapPin className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-87" />}
          {classRecord.location}
        </div>
        <div className="flex items-center text-sm text-gray-700" data-id="element-88">
          <Users className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-89" />
          {classRecord.instructorName}
        </div>
      </div>

      <Button variant={isCancelled ? 'outline' : 'primary'} className="w-full" onClick={() => onClick(classRecord)} data-id="element-90">
        {isCancelled ? 'View Details' : 'Register / Details'}
      </Button>
    </Card>;
}